import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { FileCheck2, Upload } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { uploadDocument } from "../../api/documents";
import { fileUrlAuth } from "../../api/fileUrl";
import { compressImage } from "../../lib/imageCompress";

const MAX_BYTES = 5 * 1024 * 1024;

export const DocumentUpload = ({ label, kind, value, onChange, testId }) => {
  const { t } = useTranslation();
  const input = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const prepared = await compressImage(file);
      if (prepared.size > MAX_BYTES) {
        toast.error(t("personal.fileTooLarge"));
        return;
      }
      const res = await uploadDocument(prepared, kind);
      onChange(res.url);
      toast.success(t("personal.uploaded"));
    } catch (err) {
      const code = err?.response?.data?.detail?.code;
      toast.error(code === "file_too_large" ? t("personal.fileTooLarge") : t("errors.generic"));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <p className="label-xs mb-2">{label}</p>
      <div className="flex items-center gap-2">
        <NeuButton type="button" className="flex items-center gap-2 px-4 py-2" disabled={busy} data-testid={testId} onClick={() => input.current?.click()}>
          <Upload className="h-4 w-4" /> {t("personal.upload")}
        </NeuButton>
        {value ? (
          <a href={fileUrlAuth(value)} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-xs font-semibold text-success" data-testid={`${testId}-view`}>
            <FileCheck2 className="h-4 w-4" /> {t("personal.view")}
          </a>
        ) : null}
      </div>
      <input ref={input} type="file" accept="image/*,application/pdf" className="hidden" onChange={pick} />
    </div>
  );
};
